'use client';

import React, { useMemo, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import Checkbox from 'components/consumer/Checkbox';

const DEFAULT_LIMIT = 10;
const SHOW_MORE_LIMIT = 500;

const ProductTypeRefinementList = () => {
  const { items, refine } = useRefinementList({
    attribute: 'type',
    limit: SHOW_MORE_LIMIT,
  });
  const [showMore, setShowMore] = useState(false);

  const itemsWithHits = useMemo(
    () => items?.filter(item => item.count > 0) || [],
    [items]
  );

  const isAnyRefined = itemsWithHits?.some(item => item.isRefined) || false;

  // CON-7939: There is currently an Algolia context issue that results in the
  // hits count for each item not being updated correctly when any of the named
  // filters are checked - but they still reset when the search terms change.
  // We will fix this in Searchandising Phase 2.1.
  // For the Product Type filter ONLY (since it only supports one value per product),
  // instead we use the following logic here:
  // - If no filters are currently applied, show all items with hits > 0
  // - If any filters are currently applied, only show the items that are currently refined
  const validItems = useMemo(
    () => itemsWithHits.filter(item => !isAnyRefined || item.isRefined),
    [itemsWithHits, isAnyRefined]
  );

  const displayedItems = showMore
    ? validItems
    : validItems.slice(0, DEFAULT_LIMIT);
  const hasMore = validItems.length > DEFAULT_LIMIT;

  return (
    <div className="[&_.group>span:first-of-type]:rounded">
      <ul className="list-none p-0 m-0">
        {displayedItems.map(item => (
          <li key={item.value} className="cursor-pointer mt-4">
            <Checkbox
              id={`product-type-${item.value}`}
              checked={item.isRefined}
              onClick={() => refine(item.value)}
              size="sm"
              className="group flex relative cursor-pointer"
            >
              <span className="[&_a]:text-brand [&_a]:z-[2] [&_a]:focus:underline group-hover:text-brand text-gray pl-1 text-sm mt-px">
                {item.label}
              </span>
            </Checkbox>
          </li>
        ))}
      </ul>
      {hasMore && (
        <button
          type="button"
          onClick={() => setShowMore(!showMore)}
          className="text-sm font-bold text-brand mt-3 bg-transparent border-0 cursor-pointer p-0 font-sans"
        >
          {showMore ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
};

export default ProductTypeRefinementList;
